/* eslint-disable import/no-cycle */
import { useEffect, useState } from 'react';
import { Subject } from 'rxjs';

import NewVehicleModal from 'domains/landing-autos/containers/app/containers/main-section/modals/new-vehicle-modal/new-vehicle-modal';
import ModalEditCustomerInfo from '../shared/modal-edit-customer-info/modal-edit-customer-info';

interface StateConfig {
  open: boolean;
  type: 'vehicle' | 'customer';
}

const modal$ = new Subject<StateConfig>();

export const useModalEditState = () => {
  const [element, setElement] = useState<any>(null);

  useEffect(() => {
    const sub = modal$.subscribe((state) => {
      if (!state.open) {
        setElement(null);
        return;
      }

      switch (state.type) {
        case 'vehicle':
          setElement(
            <NewVehicleModal
              handleClose={() => {
                setElement(null);
              }}
              isOpen={true}
              isEdit={true}
            />,
          );
          break;

        case 'customer':
          setElement(
            <ModalEditCustomerInfo
              handleClose={() => {
                setElement(null);
              }}
              isOpen={true}
            />,
          );
          break;

        default:
          break;
      }
    });

    return () => sub.unsubscribe();
  }, []);

  return {
    element,
  };
};

export const setModalEditState = ({ open, type }: StateConfig) => {
  modal$.next({
    open,
    type,
  });
};
